module.exports = __webpack_public_path__ + "static/media/game-background-identify.b37630a5.jpg";